import {initialize} from './rules'

export function init(){
   try {
      initialize()
   } catch (err) {
      throw err
   }
}